import React, { useContext } from 'react'
import styled from 'styled-components';
import { AgendaContext } from '../context/AgendaContext';
import { Color, Colors } from '../styles/Colors';
import { useTranslation } from 'react-i18next';

const OptionContainer = styled.div`
    display: flex; 
`;

const Option = styled.div`
    display: flex; 
    justify-content: flex-start; 
    align-items: center; 


    & > label {
        margin: 0 8px 0 8px; 
        font-weight: 400; 
    }
    
    & > input[type='radio'] {
        padding: 0; 
        margin: 0;
        border: 2px solid ${Color(Colors.black)}; 
        
        &:checked {
            border-color: ${Color(Colors.black)}; 
        }

        &:checked::after { 
            background-color: ${Color(Colors.black)};  
        }
    
    }
`;

const SelectMeetingType = () => {
    const { t } = useTranslation(); 
    const { selectedMeetingType, setSelectedMeetingType } = useContext(AgendaContext); 

    const handleSelectedMeetingType = (event) => {
        const value = event.target.value;
        setSelectedMeetingType(value);
        localStorage.setItem('selected_meeting_type', value);
    }

    return (
        <OptionContainer>
            <Option>
                <label>{`${t('meetingDetails.location.radioButtonLabels.online')}:`}</label>
                <input
                    type='radio'
                    value='online'
                    checked={selectedMeetingType === 'online'}
                    onChange={handleSelectedMeetingType}
                />
            </Option>

            <Option>
                <label>{`${t('meetingDetails.location.radioButtonLabels.inPerson')}:`}</label>
                <input
                    type='radio'
                    value='inPerson'
                    checked={selectedMeetingType === 'inPerson'}
                    onChange={handleSelectedMeetingType}
                />
            </Option>

            <Option>
                <label>{`${t('meetingDetails.location.radioButtonLabels.hybrid')}:`}</label>
                <input
                    type='radio'
                    value='hybrid'
                    checked={selectedMeetingType === 'hybrid'}
                    onChange={handleSelectedMeetingType}
                />
            </Option>
        </OptionContainer>
    )
}

export default SelectMeetingType